"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.dropTarget = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDnd = require("react-dnd");

var _classnames = _interopRequireDefault(require("classnames"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));
/**
 * specifies how to handle drag and drop events
 */


var dropTarget = {
  drop: function drop(props, monitor) {
    var item = monitor.getItem();
    props.handleColumnReorder(item.columnKey, props.columnKey, props.rightSide);
  }
};
/**
 * Specifies the props to inject into your component via react-dnd.
 */

exports.dropTarget = dropTarget;

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}
/**
 * component
 */


var ColumnReorderDropTarget = function ColumnReorderDropTarget(props) {
  var _cx;

  return props.connectDropTarget(_react.default.createElement("div", {
    style: props.style,
    className: (0, _classnames.default)(_CwDataGrid.default.columnReorderDropTarget, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwDataGrid.default.rightSide, props.rightSide), (0, _defineProperty2.default)(_cx, _CwDataGrid.default.hasFilterTypes, props.hasFilterTypes), _cx))
  }, !props.rightSide && props.isOver && _react.default.createElement("div", {
    className: _CwDataGrid.default.leftBorder
  }), props.rightSide && props.isOver && _react.default.createElement("div", {
    className: _CwDataGrid.default.rightBorder
  })));
};

ColumnReorderDropTarget.propTypes = {
  columnKey: _propTypes.default.string.isRequired,
  hasFilterTypes: _propTypes.default.bool,
  rightSide: _propTypes.default.bool,
  style: _propTypes.default.object,
  handleColumnReorder: _propTypes.default.func,
  // Injected by React DnD:
  connectDropTarget: _propTypes.default.func.isRequired,
  isOver: _propTypes.default.bool.isRequired
};
ColumnReorderDropTarget.defaultProps = {
  hasFilterTypes: false,
  rightSide: false,
  style: {}
};

var _default = (0, _reactDnd.DropTarget)('ColumnHeader', dropTarget, collect)(ColumnReorderDropTarget);

exports.default = _default;